module.exports = __webpack_public_path__ + "img/photo-18.f78fc317.jpg";